import { Action } from 'redux';
import { UserAgentStats } from '@dev/ee-api/ee-api-models';
import { DevicesParams, DevicesChannelParams } from '@api/services/ElasticApi';

export enum DeviceDetailsActionTypes {
    GET_DEVICE_DETAILS = '@@reports/GET_DEVICE_DETAILS',
    GET_DEVICE_DETAILS_SUCCESS = '@@reports/GET_DEVICE_DETAILS_SUCCESS',
    GET_DEVICE_DETAILS_ERROR = '@@reports/GET_DEVICE_DETAILS_ERROR',
    GET_DEVICE_DETAILS_CHANNELS = '@@reports/GET_DEVICE_DETAILS_CHANNELS',
    GET_DEVICE_DETAILS_CHANNELS_SUCCESS = '@@reports/GET_DEVICE_DETAILS_CHANNELS_SUCCESS',
    GET_DEVICE_DETAILS_CHANNELS_ERROR = '@@reports/GET_DEVICE_DETAILS_CHANNELS_ERROR',
}

export interface DeviceDetailsState {
    deviceDetailsStats: UserAgentStats[];
    loading: boolean;
}

export interface DevicesFetchStartAction extends Action {
    type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS;
    payload: DevicesParams;
}

export interface DevicesFetchSuccessAction extends Action {
    type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_SUCCESS;
    payload: DeviceDetailsState;
}

export interface DevicesFetchErrorAction extends Action {
    type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_ERROR;
}

export interface DevicesChannelsFetchStartAction extends Action {
    type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_CHANNELS;
    payload: DevicesChannelParams;
}

export interface DevicesChannelsFetchSuccessAction extends Action {
    type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_CHANNELS_SUCCESS;
    payload: DeviceDetailsState;
}
export interface DevicesChannelsFetchErrorAction extends Action {
    type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_CHANNELS_ERROR;
}
